import { TimeBufferUnit } from 'automations/data/timeBuffer';
import { z } from 'zod';

// The one definition of the +/- offset that hangs off a date/time value. Mirrors
// Validators::AutomationHosts::Shared::TimeBufferSchema on the backend — a shape
// mismatch there saves and runs while doing nothing, so these must not drift.
export const TimeBufferSchema = z.object({
  value: z.number({ required_error: 'Buffer amount is required' })
    .int('Buffer amount must be a whole number')
    .positive('Buffer amount must be at least 1'),
  unit: z.nativeEnum(TimeBufferUnit, { required_error: 'Buffer unit is required' }),
  isAfter: z.boolean(),
});

export const AnchoredTimeSchema = TimeBufferSchema.extend({
  dependsOn: z.string().min(1, 'Choose a date & time to anchor to'),
});

export type TimeBuffer = z.infer<typeof TimeBufferSchema>;
export type AnchoredTime = z.infer<typeof AnchoredTimeSchema>;
